import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if @renderInPlace}}{{yield}}{{else}}{{#in-element @destinationElement insertBefore=null}}{{yield}}{{/in-element}}{{/if}}")